var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 3C11.284 3 10 4.626 10 4.626S8.716 3 6.4 3C3.97 3 2 4.915 2 7.278 2 11.556 10 17 10 17s8-5.444 8-9.722C18 4.915 16.03 3 13.6 3zM10 15.07c-2.786-2.08-6.4-5.532-6.4-7.792 0-1.501 1.256-2.722 2.8-2.722 1.922 0 3.6 2.26 3.6 2.26s1.712-2.26 3.6-2.26c1.544 0 2.8 1.22 2.8 2.722 0 2.26-3.614 5.713-6.4 7.792z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.81468bd26651f23f7cd06df9d7767d24.svg";
export { ForwardRef as ReactComponent };